import React, { useEffect } from "react";
import styles from './index.module.scss';
import { queryByClaimsNo } from '@src/services/Forensics';
import { checkToken } from "@src/services/CheckToken";
import { useNavigate } from "react-router-dom";
//导入antd
import { Form, Input, Button, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import icon from '@imgs/forensics/pic.png'
//导入react-redux
import { useSelector,useDispatch } from "react-redux";
import { clearState } from "@src/store/actions/user";

//导入组件
import { SmsVerificationCode } from '@src/components/form/sms-verification-code'
import { ForensicsModal } from "./components/ForensicsModal";

export const Forensics = () => {
    //判断token是否过期
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = useSelector((state: any) => state.user.userInfo.token);
    useEffect(() => {
        checkToken({token}).then(res => {
            if(res.data === false) {
                //token过期
                message.error('登录已过期，请重新登录');
                dispatch(clearState());
                navigate('/');
            }
        })
    }, [])
    //表单
    const [form] = Form.useForm();
    //查询成功的弹窗
    const [forensicsModal, setForensicsModal] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [evidenceName, setEvidenceName] = React.useState('');
    //证据包详情数据列表
    const [evidenceList, setEvidenceList] = React.useState([]);

    //表单提交的方法
    const onFinish = (values: any) => {
        setLoading(true);
        setEvidenceName(values.claimsNo);
        queryByClaimsNo({
            claimsNo: values.claimsNo,
            smsCode: values.smsCode,
        }).then((res: any) => {
            setForensicsModal(true);
            //得到数据包里面的数据列表
            setEvidenceList(res.data);
        })
        .finally(() => {
            setLoading(false);
        })
    };

    //是否可查询
    const [isQuery, setIsQuery] = React.useState(false);
    const changeQuery = (value: boolean) => {
        setIsQuery(value);
    }

    return (
    <div className={styles.forensics}>
        {/* 背景图片 */}
        <img src={require('@imgs/forensics/bg.png').default} className={styles.bg}/>
        <ForensicsModal forensicsModal={forensicsModal} setForensicsModal={setForensicsModal} evidenceList={evidenceList} loading={loading} claimsNo={evidenceName}/>
        <div className={styles.content}>
            <img src={icon}/>
            <div className={styles.box}>
                {/* 文件验证表单,里面有文件验证的标题和输入存证编号input框和上传源文件的上传框 */}
                <div className={styles.form}>
                    <div className={styles.form_title}>证据提取</div>
                    <Form
                        form={form}
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="claimsNo"
                            rules={[
                                { required: true, message: '请输入宝象编号' },
                            ]}
                            className={styles.form_item}
                        >
                            <div>
                                <Input
                                    size={'large'}
                                    placeholder="请输入宝象编号"
                                    className={styles.form_input}
                                    prefix={
                                        <SearchOutlined className={styles.icon} />
                                    }
                                />
                                <Button 
                                    type="primary" 
                                    size={'large'}
                                    disabled={!isQuery}
                                    className={styles.get_baoxia_code}
                                    htmlType="submit"
                                >
                                    查询
                                </Button>
                            </div>
                        </Form.Item>
                        <SmsVerificationCode
                            form={form}
                            isNeedCaptcha={true}
                            useType={'evidenceQuery'}
                            needPrefix={true}
                            size={'large'}
                            changeQuery={changeQuery}
                        />
                    </Form>
                </div>          
            </div>
        </div>
    </div>)
}